var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useCallback, useEffect, useState } from "react";
/*
 * A pick (of a pump or a cup) only shows as selected once Tacton has
 * answered, which takes a moment. Until then the picker shows the option it
 * asked for, so that a quick click in the next column builds on it rather
 * than on the option before. Tacton handles the requests in order, so the
 * last pick wins either way.
 *
 * `committedOptions` are what the selected nodes `nodeIds` have now; with
 * several nodes selected the first one's stands for them all, as in the
 * sidebar section's value. `commitValue` puts an option on the nodes.
 */
export var usePendingPick = function (options, committedOptions, commitValue, nodeIds) {
    var committed = committedOptions[0];
    var nodeKey = nodeIds.join();
    var _a = __read(useState(), 2), pending = _a[0], setPending = _a[1];
    var pendingOption = (pending === null || pending === void 0 ? void 0 : pending.nodeKey) === nodeKey
        ? options.find(function (option) { return option.value === pending.value; })
        : undefined;
    useEffect(function () {
        if (pending && pending.value === (committed === null || committed === void 0 ? void 0 : committed.value)) {
            setPending(undefined);
        }
    }, [pending, committed === null || committed === void 0 ? void 0 : committed.value]);
    var commit = useCallback(function (value) {
        setPending({ value: value, nodeKey: nodeKey });
        commitValue(value);
    }, [nodeKey, commitValue]);
    /* Whether every selected node has (or is about to have) `value`. */
    var isPicked = useCallback(function (value) {
        return pendingOption
            ? pendingOption.value === value
            : committedOptions.length > 0 &&
                committedOptions.every(function (option) { return option.value === value; });
    }, [pendingOption, committedOptions]);
    return { picked: pendingOption !== null && pendingOption !== void 0 ? pendingOption : committed, commit: commit, isPicked: isPicked };
};
